import axiosInstance from "./api";

/**
 * The account's preference for the live "+N vote" progress toasts.
 *
 * Its own service, alongside email-preferences.service.js, rather than a method
 * on auth.service.js: that file talks to bare `axios` (see getUser) and so
 * misses the refresh interceptor, which would log a user out mid-toggle when
 * their token happened to expire. `axiosInstance` carries the interceptor and
 * the bearer token, so nothing here handles auth by hand.
 *
 * Both calls hit the same path. The backend derives the account from the token
 * and reads no id from the request, so there is deliberately no user id to pass
 * in from here.
 *
 * Response shape (both methods):
 *   {
 *     vote_toasts: boolean,  // true = keep showing the progress toasts
 *     available:   boolean   // false while the DB column is missing
 *   }
 */
const PATH = "/user/notification-preferences";

class NotificationPreferencesService {
  /** Current preference for the signed-in account. */
  get() {
    return axiosInstance.get(PATH);
  }

  /**
   * @param {boolean} voteToasts true to keep showing the vote progress toasts.
   *
   * The parameter is the SHOWN polarity, matching the switch on screen, and the
   * backend stores it the same way round. Kept identical on purpose: a toggle
   * whose meaning is inverted in one of the two layers is the classic way to
   * ship a switch that reads as the reverse of its label.
   */
  set(voteToasts) {
    return axiosInstance.post(PATH, { vote_toasts: Boolean(voteToasts) });
  }
}

export default new NotificationPreferencesService();
